// @flow

// Vendors
import React from 'react';

// Components
import { Thumbnail } from '../../components';

// Types
type Props = {};

const ProjectsGridItemPlaceholder = ({  }: Props) => (
  <span className="project-grid__item project-grid__item--placeholder">
    <Thumbnail placeholderSize={{ width: 1280, height: 940 }} />
  </span>
);

export default ProjectsGridItemPlaceholder;
